import { ActionsUnion, createAction } from "../definitions";
import { ISystemSettings, SystemSettingsActionTypes } from "./types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SystemSettingsActions = {
    setSystemSettings: (payload: ISystemSettings) => createAction(SystemSettingsActionTypes.SET_SYSTEMSETTINGS, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SystemSettingsActions = ActionsUnion<typeof SystemSettingsActions>;